<template>
  <div
    class="
      tw-flex
      tw-flex-col
      tw-overflow-hidden
      tw-rounded
      tw-border
      tw-border-solid
      tw-border-sf-slate-lighter-1
      tw-text-sm
    "
    :style="{
      minHeight: PINNED_CHART_HEIGHT_DEFAULT,
      maxHeight: PINNED_CHART_HEIGHT_DEFAULT,
    }"
    data-testid="pinned-report-statement"
  >
    <div
      class="
        tw-flex
        tw-items-center
        tw-justify-end
        tw-gap-3
        tw-px-3
        tw-py-2
        tw-bg-sf-slate-subtle-1
        tw-border-0
        tw-border-b
        tw-border-solid
        tw-border-sf-slate-lighter-1
        tw-text-xs
        tw-text-sf-slate-light-2
      "
    >
      <span>{{ statement.periodLabel }}</span>
    </div>
    <div
      v-for="(row, index) in statement.rows"
      :key="index"
      class="
        tw-flex tw-items-baseline tw-justify-between tw-gap-3 tw-px-3 tw-py-1.5
      "
      :class="{ 'tw-font-medium tw-bg-sf-slate-subtle-1': row.level === 0 }"
      data-testid="pinned-report-statement-row"
    >
      <span class="tw-truncate">{{ row.name }}</span>
      <span class="tw-whitespace-nowrap">{{ formatRowValue(row.value) }}</span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { formatCompact } from '@app/application/report/screens/graphs-echarts/utils/format'
import { PINNED_CHART_HEIGHT_DEFAULT } from '@app/application/report/constants'
import type { StatementPreview } from '@app/application/report/types'
import type { Locale } from '@app/shared/types/locale'

defineOptions({ name: 'PinnedReportStatement' })

const props =
  defineProps<{
    statement: StatementPreview
    locale: Locale
  }>()

function formatRowValue(value: number | null): string {
  if (value === null) return '-'
  if (Object.is(value, -0)) value = 0
  if (value < 0) {
    return props.statement.negativeFormat.replace(
      '%n',
      formatCompact(Math.abs(value), props.locale)
    )
  }

  return formatCompact(value, props.locale)
}
</script>
